import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberWithCommas',
    standalone: false
})
export class NumberWithCommasPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value === null || value === undefined) {
      return '-';
    }

    // Convert value to string in case it's a number
    const numberValue = value.toString();

    // Regular expression for adding commas to a number
    return numberValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
